// Copyright (c) 2018 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../../shared/components/editable-field';
import LabeledFormInput from '../../../../../shared/components/labeled-form-input';
import PartReturnQuestion from '@deere/cps-it.warranty-model-factory/lib/part-return-question';
import {getAnswerValue} from '../../../services/get-answer-value';

function handleAnswerChange(event) {

    this.props.onAnswerChange(event.target.value, this.question.id, this.props.questions);

}

const Questions = props =>
    <div className='questions'>
        {props.questions.map(question =>
            <div key={question.question}>
                <LabeledFormInput
                    className={`question ${question.isMandatory ? 'required' : ''}`}
                    label={question.question}
                    labelNeedsTranslation={false}
                >
                    <EditableField
                        isEditable={props.isEditableAndAccessible}
                        value={getAnswerValue(question)}
                    >
                        {question.type === 'S' ?
                            <textarea
                                onChange={{props, question}::handleAnswerChange}
                                value={question.answer}
                            /> :
                                <select
                                    onChange={{props, question}::handleAnswerChange}
                                    value={question.answer}
                                >
                                    <option
                                        key=''
                                        value=''
                                    >
                                    </option>
                                    {question.options.map(option =>
                                        <option
                                            key={option.key}
                                            value={option.key}
                                        >
                                            {option.value}
                                        </option>
                                    )}
                                </select>
                        }
                    </EditableField>
                </LabeledFormInput>
            </div>
        )}
    </div>;

Questions.displayName = 'Questions';
Questions.propTypes = {
    isEditableAndAccessible: PropTypes.bool.isRequired,
    onAnswerChange: PropTypes.func.isRequired,
    questions: PropTypes.arrayOf(PropTypes.instanceOf(PartReturnQuestion)).isRequired
};

export default Questions;



// WEBPACK FOOTER //
// ./src/part-requests/request-details/components/form-fields/information-request-form/questions.js